<template>
  <div class="min-h-full antialiased font-inter text-gray-brand-900 bg-gray-brand-100">
    <div class="w-full">
      <main v-if="loading" class="max-w-5xl mx-auto pt-24 flex justify-center">
        <div class="text-center py-4"></div>
      </main>
      <main v-else class="max-w-5xl mx-auto pt-24 flex justify-center">
        <p>Merchant not found.</p>
        <img :src="svg" alt="Page not found" />
      </main>
    </div>
  </div>
</template>

<script>
import merchantFetch from '@/utils/merchantFetch'
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

export default {
  name: 'NotFound',
  setup() {
    const router = useRouter()
    const store = useStore()
    const loading = ref(true)
    const svg = require('@/assets/404.svg')

    onMounted(async () => {
      try {
        const currentSlug =
          router.currentRoute.value.params.pathMatch || router.currentRoute.value.path.split('/').pop()
        const response = await merchantFetch('franchise')
        const franchiseData = response.data.attributes

        let matchingStore = null
        for (const location of franchiseData.locations) {
          if (location.stores) {
            matchingStore = location.stores.find((store) => store.slug.toLowerCase() === currentSlug.toLowerCase())
            if (matchingStore) break
          }
        }

        if (matchingStore) {
          await goToStore(matchingStore)
        } else {
          loading.value = false
        }
      } catch (error) {
        console.error('Error checking franchise stores:', error)
        loading.value = false
      }
    })

    const goToStore = async (storeData) => {
      store.commit('SET_SELECTED_STORE_SLUG', storeData.slug)
      await store.dispatch('getToken', {
        subdomain: window.location.host,
        store_slug: storeData.slug
      })
      router.push({ name: 'BottleFactory', params: { storeSlug: storeData.slug, storeId: storeData.id } })
    }

    return {
      svg,
      loading
    }
  }
}
</script>
